"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Breadcrumb = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var __1 = require("../");

var frontend_common_1 = require("@ryerson/frontend.common");

var Breadcrumb = function Breadcrumb(_ref) {
  var className = _ref.className,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "primary" : _ref$type,
      data = _ref.data,
      _ref$gatsby = _ref.gatsby,
      gatsby = _ref$gatsby === void 0 ? false : _ref$gatsby,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "md" : _ref$size;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var crumbs = data;
  var crumbLabels = [];

  if (typeof document !== "undefined") {
    crumbLabels = ("Home" + location.pathname).split("/").filter(function (value) {
      return value !== "";
    });
    crumbLabels.pop();
  }

  var linkToPath = function linkToPath(crumbLabel, index) {
    var homePage = "/";

    if (index < 2) {
      return index === 0 ? homePage : homePage + crumbLabel;
    } else {
      var linkTo = location.pathname.split("/");
      linkTo.splice(index + 1, linkTo.length);
      return linkTo ? linkTo.join("/") : homePage;
    }
  };

  var getLink = function getLink(crumb, crumbLabel, index, isData) {
    return (0, jsx_runtime_1.jsx)("span", {
      style: {
        marginRight: "10px"
      },
      children: (0, jsx_runtime_1.jsxs)(__1.Link, {
        gatsby: gatsby,
        to: isData && crumb ? crumb.url : linkToPath(crumbLabel, index),
        color: theme.colors[type].text,
        size: size,
        children: [isData && crumb ? crumb.label : getTitleCase(crumbLabel), " \xA0 /"]
      }, index)
    }, index);
  };

  var getTitleCase = function getTitleCase(crumbLabel) {
    return crumbLabel.split("-").map(function (crumb) {
      return (0, frontend_common_1.titleCase)(crumb);
    }).join(" ");
  };

  return (0, jsx_runtime_1.jsx)("span", {
    className: className,
    children: crumbs ? crumbs.map(function (crumb, index) {
      return getLink(crumb, "", index, true);
    }) : crumbLabels.length > 1 && crumbLabels.map(function (crumbLabel, index) {
      return getLink(null, crumbLabel, index, false);
    })
  });
};

exports.Breadcrumb = Breadcrumb;